export interface CompanyMatch {
  companyId: string;
  companyName: string;
  companyGST?: string;
  similarityScore: number;
}

export interface CompanyReviewRequest {
  reviewId: string;
  extractedCompanyName: string;
  companyGST?: string;
  fileName?: string;
  orchestrationInstanceId?: string;
  batchId?: string;
  currentPage?: number;
  totalItems?: number;
  pageSize?: number;
}

export enum CompanyReviewDecisionType {
  MapToExisting = 'MapToExisting',
  CreateNew = 'CreateNew',
}

export enum CompanyReviewStatus {
  Pending = 'Pending',
  Completed = 'Completed',
}

// PascalCase properties to match the .NET backend API contract (sent directly without transformation)
export interface CompanyReviewDecision {
  ReviewId: string;
  Decision: CompanyReviewDecisionType;
  SelectedCompanyId?: string;
  NewCompanyName?: string;
}

// PascalCase properties to match the .NET backend API contract (sent directly without transformation)
export interface BatchCompanyReviewRequest {
  BatchId: string;
  OrchestrationInstanceId: string;
  CompanyReviews: CompanyReviewRequest[];
}

export interface CompanyReviewWithMatches extends CompanyReviewRequest {
  matchingCompanies: CompanyMatch[];
}
